import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "./ga";

/**
 * Sends a GA4 `page_view` on every client-side route change.
 * Must be rendered inside the Router. Renders nothing.
 */
export function AnalyticsPageViews() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
